var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"home"},[_c('AppSearch'),_c('AppHeader'),_c('AppHelp'),_c('v-main',[(_vm.$store.state.loading)?_c('AppSpinner'):_vm._e(),_c('router-view')],1),_c('AppFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }